import { ConfigurationError } from '@cian/peperrors/shared';

// eslint-disable-next-line react/no-deprecated
import { hydrate } from 'react-dom';

import { Application } from 'shared/components/Application';
import type { IClientSideState } from 'shared/services/ClientSideState';
import type { IServerSideState } from 'shared/services/ServerSideState';
import type { IApplicationContext } from 'shared/types/ApplicationContext';

type Dependencies = {
  context: IApplicationContext;
  serverSideState: IServerSideState;
  clientSideState: IClientSideState;
};

const domain = 'src/browser/services/renderApplication/service.tsx';

export function renderApplication(dependencies: Dependencies): void {
  const { context, serverSideState, clientSideState } = dependencies;
  const { config, logger } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    const configurationError = new ConfigurationError({ domain, message: `Unable to find element #${projectName}` });

    logger.error(configurationError.message, { domain: configurationError.domain });

    throw configurationError;
  }

  hydrate(
    <Application clientSideState={clientSideState} context={context} serverSideState={serverSideState} />,
    rootElement,
  );
}
